import DesignerState from "../DesignerState";
import { DesignerModalState } from "../../modal/DesignerModalState";
import QrPreviewState from "../../qrpreview/QrPreviewState";
import ColorState from "../color/ColorState";
import EyesAndModulesState from "../eyesAndModules/EyesAndModulesState";
import LogoState from "../logo/LogoState";
import FrameAndCaptionsState from "../frameAndCaption/FrameAndCaptionsState";
import CaptionState from "../frameAndCaption/CaptionState";
import {v4 as uuidv4} from 'uuid';
import ImageAndCharacteristicsState from "../imageAndCharacteristics/ImageAndCharacteristicsState";
import {MediaFile} from "../../../../models/mediaFiles/MediaFileModel";
import {getRoot} from "mobx-state-tree";

export function initDesignerTemplateModal(dashboardStore, qrConfigSelectStore, groupSelectState, isView, dimensionsMultiSelectStore, tagSelectStore, mediaFileSelectState, isMediaFileEnabled) {
  const designerViewState = initDesignerViewState(dashboardStore, qrConfigSelectStore, groupSelectState, isView, mediaFileSelectState, dimensionsMultiSelectStore, tagSelectStore, isMediaFileEnabled);

    const designerModalState = DesignerModalState.create({
        designerViewStore: designerViewState,
        isEditCodePage: false,
        qrPreviewStore: QrPreviewState.create({}), // rootStore.rootUiStore.qrPreviewStore
        // dashboardStore: dashboardStore,
        defaultImageConfig: dashboardStore.apps.defaultImageConfig,
        v1ImageConfig: dashboardStore.apps.v1ImageConfig,
        isView: isView
    })
    return designerModalState;
}

export function initLogoStore(mediaFileSelectState, dimensionsMultiSelectStore, tagSelectStore, isMediaFileEnabled) {
  // Get the MediaFileSelectStateManager from root store
  const rootStore = mediaFileSelectState?.store ? getRoot(mediaFileSelectState.store) : null;
  const mediaFileManager = rootStore?.rootUiStore?.mediaFileSelectStateManager;
  
  // Create separate MediaFileSelectState instances for logo and background
  let logoMediaFileSelectState = null;
  let backgroundMediaFileSelectState = null;
  
  if (mediaFileManager) {
    // Create logo state with consumer callback that will be set later
    logoMediaFileSelectState = mediaFileManager.createMediaFileSelectState('designerLogo', null, isMediaFileEnabled);
    
    // Create background state with consumer callback that will be set later  
    backgroundMediaFileSelectState = mediaFileManager.createMediaFileSelectState('designerBackground', null, isMediaFileEnabled);
  }

  const logoStore = LogoState.create({
        logoMediaFileSelectState: logoMediaFileSelectState,
        backgroundMediaFileSelectState: backgroundMediaFileSelectState,
        backgroundMediaFile: MediaFile.create({
          uuid:"mediaFileBackground",
          singleUseFile: true,
          liveLinks: {
            thumbnail: "",
            small: "",
            medium: "",
            large: "",
            original: ""
          },
          fileFormat: "png",
          dimensionsMultiSelectStore: dimensionsMultiSelectStore,
          tagSelectStore: tagSelectStore
        }),
        logoMediaFile: MediaFile.create({
          uuid:"mediaFileLogo",
          singleUseFile: true,
          liveLinks: {
            thumbnail: "",
            small: "",
            medium: "",
            large: "",
            original: ""
          },
          fileFormat: "png",
          dimensionsMultiSelectStore: dimensionsMultiSelectStore,
          tagSelectStore: tagSelectStore
        })
    });

  // Set up consumer callbacks for both states
  if (logoMediaFileSelectState) {
    logoMediaFileSelectState.setConsumer((selectedFile, fieldName) =>
      logoStore.handleMediaFileSelection(selectedFile, 'mediaFileCode_logo')
    );
  }

  if (backgroundMediaFileSelectState) {
    backgroundMediaFileSelectState.setConsumer((selectedFile, fieldName) =>
      logoStore.handleMediaFileSelection(selectedFile, 'mediaFileCode_background')
    );
  }

  // Load existing media files if needed
  logoStore.loadMediaFiles();
  return logoStore;
}

export function initDesignerViewState(dashboardStore, qrConfigSelectStore, groupSelectState, isView, mediaFileSelectState, dimensionsMultiSelectStore, tagSelectStore, isMediaFileEnabled = false) {
    const frameAndCaptionsStore = FrameAndCaptionsState.create({
        captionRows: [CaptionState.create({ id: uuidv4(), captionTextPosition: 'Top', captionFontSize: 50, captionContent: '', captionColor: '#000000' }) ],
        fillInColor: false,
    })

    const logoStore = initLogoStore(mediaFileSelectState, dimensionsMultiSelectStore, tagSelectStore, isMediaFileEnabled);
    const designerViewState = DesignerState.create({
        colorStore: ColorState.create({}),
        eyeStore: EyesAndModulesState.create({}),
        logoStore: logoStore,
        imageCharsStore: ImageAndCharacteristicsState.create({}),
        frameAndCaptionsStore: frameAndCaptionsStore,
        qrConfigSelectStore: qrConfigSelectStore,
        groupSelectStore:groupSelectState,
        // dashboardStore: dashboardStore,
        isView: isView,
        mediaFileSelectStore: mediaFileSelectState,
        dimensionsMultiSelectStore: dimensionsMultiSelectStore,
        tagSelectStore: tagSelectStore,
        defaultImageConfig: dashboardStore.apps.defaultImageConfig,
        v1ImageConfig: dashboardStore.apps.v1ImageConfig,
    })

    return designerViewState;
}

export const isMediaFileEnabled = (appConfigs) => {
  let isMediaFileEnabled = false
  if(appConfigs?.feature_toggles?.cmp_ui_media_files){
    isMediaFileEnabled = appConfigs.feature_toggles.cmp_ui_media_files
  }
  return isMediaFileEnabled
}
